<template>
	<section>
		<table v-if="!params.type" class="table-main grade-table">
			<colgroup>
				<col class="grade-table__category" />
				<col class="grade-table__grade" />
				<col />
				<col class="grade-table__grade" />
			</colgroup>
			<thead>
				<tr>
					<th colspan="2">카테고리 등급</th>
					<th colspan="2">브랜드 등급</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="idx in length" :key="idx">
					<template v-if="categoryGrade[idx - 1]">
						<td>
							{{ categoryGrade[idx - 1].title }}
						</td>
						<td>
							등급: Lv{{ categoryGrade[idx - 1].grade }}
							{{ getGradeName(categoryGrade[idx - 1].grade)
							}}<br />
							리뷰: {{ categoryGrade[idx - 1].reviewCnt }}
						</td>
					</template>
					<td v-else class="grade-table__empty" colspan="2">-</td>
					<template v-if="brandGrade[idx - 1]">
						<td class="grade-table__brand">
							{{ brandGrade[idx - 1].title }}
						</td>
						<td>
							등급: Lv{{ brandGrade[idx - 1].grade }}
							{{ getGradeName(brandGrade[idx - 1].grade) }}<br />
							리뷰: {{ brandGrade[idx - 1].reviewCnt }}
						</td>
					</template>
					<td v-else class="grade-table__empty" colspan="2">-</td>
				</tr>
			</tbody>
		</table>

		<table v-if="'category' == params.type" class="form">
			<tr>
				<th>카테고리</th>
				<th>등급</th>
				<th>리뷰수</th>
			</tr>

			<tr v-for="(grade, i) in categoryGrade" :key="i">
				<td>{{ grade.title }}</td>
				<td>Lv.{{ grade.grade }} {{ getGradeName(grade.grade) }}</td>
				<td>{{ grade.reviewCnt }}</td>
			</tr>
		</table>

		<table v-if="'brand' == params.type" class="form">
			<tr>
				<th>브랜드</th>
				<th>등급</th>
				<th>리뷰수</th>
			</tr>

			<tr v-for="(grade, i) in brandGrade" :key="i">
				<td>{{ grade.title }}</td>
				<td>Lv.{{ grade.grade }} {{ getGradeName(grade.grade) }}</td>
				<td>{{ grade.reviewCnt }}</td>
			</tr>
		</table>
	</section>
</template>

<script>
	import { getReviewerGrade } from '@/util.js';

	export default {
		name: 'ReviewerGrade',
		data() {
			return {
				length: 0,
				categoryGrade: [],
				brandGrade: [],
			};
		},
		computed: {
			params() {
				return this.$store.state.modal.params;
			},
		},

		created() {
			this.setList();
		},
		methods: {
			getGradeName(id) {
				return getReviewerGrade('id', id, 'name');
			},
			async setList() {
				const id = this.params.type ? this.params.id : this.params;
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/register/${id}/grade`
				);

				this.categoryGrade = data.categoryGrade || [];
				this.brandGrade = data.brandGrade || [];
				this.length = Math.max(
					this.categoryGrade.length,
					this.brandGrade.length
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.grade-table {
		table-layout: fixed;
		margin-top: 16px;

		tbody {
			th,
			td {
				text-align: left;
				white-space: nowrap;
			}

			.grade-table__empty {
				text-align: center;
			}

			.grade-table__brand {
				white-space: normal;
				word-break: break-all;
			}
		}
	}

	.grade-table__category {
		width: 180px;
	}

	.grade-table__grade {
		width: 150px;
	}
</style>
